/**
 * Format date to a month-year string
 * @param date - input date to format
 * @param strings - localized strings
 */
export var formatMonthYear = function formatMonthYear(date, strings) {
  return strings.months[date.getMonth()] + " " + date.getFullYear();
};
//# sourceMappingURL=formatMonthYear.js.map
